import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject } from 'rxjs'
import { TimeSchedule } from '../work-schedule'
import { DateTimeFormatter, LocalTime } from '@js-joda/core'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-time-schedule-slot',
  templateUrl: './time-schedule-slot.component.html',
  styleUrls: ['./time-schedule-slot.component.scss'],
  imports: [AsyncPipe],
})
export class TimeScheduleSlotComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly timeSlot$ = new BehaviorSubject<TimeSchedule>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set timeSchedule(slot: TimeSchedule) {
    this.timeSlot$.next(slot)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  // TODO maybe create isoTimeFormatterPipe in ngx-components?
  public getFormatted(time: string): string {
    if (time) {
      return LocalTime.parse(time).format(DateTimeFormatter.ofPattern('HH:mm'))
    } else {
      return ''
    }
  }
}
